
<template>
     <div>
        <!-- <div :style="'height:'+ header +'px;overflow: auto'"> -->
            <!-- <div>
              <el-checkbox label="我审批" v-model="getDataParam.my_approval" @change="updateData(1)"></el-checkbox>
              <el-checkbox label="我发起" v-model="getDataParam.my_create" @change="updateData(1)"></el-checkbox>
              <el-checkbox label="进行中" v-model="getDataParam.underway" @change="updateData(1)"></el-checkbox>
              <el-checkbox label="已完成" v-model="getDataParam.is_finish" @change="updateData(1)"></el-checkbox>
              <el-checkbox label="审批失败" v-model="getDataParam.is_failure" @change="updateData(1)"></el-checkbox>
              <el-checkbox label="我已审批" v-model="getDataParam.is_correct" @change="updateData(1)"></el-checkbox>
              <el-checkbox label="已终止" v-model="getDataParam.is_abend" @change="updateData(1)"></el-checkbox>
            </div> -->
<!-- 
            <div class="bar">
                <span>共{{lists.list.length}}条</span> -->
                <!-- <div class="fr">
                  排序
                  <el-select v-model="getDataParam.order_by" placeholder="请选择" @change="updateData(1)">
                    <el-option
                      v-for="item in order_by"
                      :key="item.value"
                      :label="item.lable"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="getDataParam.sort" placeholder="请选择" @change="updateData(1)">
                    <el-option
                      v-for="item in sort"
                      :key="item.value"
                      :label="item.lable"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-button type="primary" @click="dialogAdd_approval = true">新建审批</el-button>
                </div>
            </div> --> 
        <!-- </div> -->

        <!-- <div :style="'height:'+ (height - pagination_height - header) +'px;overflow: auto'"> -->
         <el-table :data="lists.list" :height="(height)" border @cell-click="detail">
            <el-table-column type="index" label="序号" width="100"><template slot-scope="scope"><div>{{scope.$index+1}}</div></template></el-table-column>
            <el-table-column prop="name" label="审批名称"> </el-table-column>
            <el-table-column prop="type" label="审批类型" width="200"></el-table-column>
            <el-table-column prop="user" label="申请人"></el-table-column>
            <el-table-column label="申请时间"><template slot-scope="scope"><div >{{scope.row.create_time.slice(0,10)}}</div></template></el-table-column>
            <el-table-column prop="status" label="审批状态"></el-table-column>
            <el-table-column prop="" label="审批人"><template slot-scope="scope"> <div style="margin:10px 0;"  v-for="(item,key) in  scope.row.approval_flow">{{item.name}}</div></template></el-table-column>
            <el-table-column prop="update_time" label="审批时间"></el-table-column>
            <el-table-column prop="document_count" label="文件数量" width="100"></el-table-column>
            <el-table-column prop="description" label="审批描述"><template slot-scope="scope"><div v-html="scope.row.description">{{scope.row.description}}</div></template></el-table-column>
          </el-table>
          
          <!-- <div class="list" :style="'width:'+ (width - 110) +'px;overflow: auto'">
            <table class="gridtable" >
              <thead class="thead">
                  <tr>
                      <th class='col1'>序号</th>
                      <th class='col2'>审批名称</th>
                      <th class='col3'>审批类型</th>
                      <th class='col4'>申请人</th>
                      <th class='col5'>申请时间</th>
                      <th class='col6'>审批状态</th>
                      <th class='col7'>审批人</th>
                      <th class='col8'>审批时间</th>
                      <th class='col9'>文件数量</th>
                      <th class='col10'>审批描述</th>
                  </tr>
              </thead>
            </table>
          </div>
          <div class="list" :style="'height:'+ (height - pagination_height - header-40) +'px;width:'+ (width - 110) +'px;overflow: auto'">
            <table class="gridtable" >
                <tbody class="tbody" id="resultList"> -->
                   <!--  <tr>
                        <td class='col1' rowspan='2'>9999</td>
                        <td class='col2' rowspan='2'>北京</td>
                        <td class='col3' rowspan='2'>
                            京B1234 - 一一一一一一一一一一<br>
                            1000000 (23:59安装)
                        </td>
                        <td class='col4'>17:00:00</td>
                        <td class='col5' rowspan='2'>23:07:36</td>
                        <td class='col6'>23:08:53</td>
                        <td class='col7' rowspan='2'><span class='link' title='点击查看日志列表'>23:08:53</span></td>
                        <td class='col8' rowspan='2'><span class='link' title='点击查看不亮灯报障列表'>23:08:53</span></td>
                        <td class='col9' rowspan='2'><span class='link' title='点击查看站点照片列表'>23:08:53</span> <span class='link' title='点击查看观察点照片列表'>23:08:53</span></td>
                    </tr>
                     <tr>
                        <td class='col4'>00:30:00</td>
                        <td class='col6'>00:30:07(+1)</td>
                    </tr> -->
                <!-- </tbody>
            </table>
          </div> -->

        <!-- </div> -->
        <!-- <div :style="'height:'+ pagination_height +'px;overflow: auto'">
            <el-pagination @current-change="updateData" background :page-size="pageSize" layout="prev, pager, next" :total="lists.count"></el-pagination>
        </div> -->

       <el-dialog
          title="文档编辑"
          :visible.sync="dialogEdit"
          width="80%"
          :before-close="handleClose">
          <div  v-for="item in templates" class="moduel_input" v-if="dialogEdit">
              <span style="color:red;"  v-if="item.required==1">*</span>
              <v-input v-if="item.type=='input'" :moduel="item" :projectData ="dataEdit" > </v-input>
              <v-datepicker v-if="item.type=='TimePicker'" :moduel="item" :projectData="dataEdit"  v-model='dataEdit[item.key_name]'> </v-datepicker>
              <v-select v-if="item.type=='select'" :moduel="item" :projectData.sync ="dataEdit" v-model='dataEdit[item.key_name]' :ref="item.key_name"  v-on:listenToChildEvent="getTaskList"> </v-select>
              <v-selectObj v-if="item.type=='select_by_api'" :moduel.sync="item" :projectData.sync="dataEdit" v-model='dataEdit[item.key_name]' :ref="item.key_name" v-on:listenToChildEvent="clearFiles"> </v-selectObj>
              <v-text v-if="item.type=='text'" :moduel="item" :projectData="dataEdit"  > </v-text>
              <div style="vertical-align: top;" class='moduel_input'>
                  <el-upload
                    class="upload-demo"
                    :on-success="handleSuccess"
                    :action="upload_url"
                    :multiple='false'
                    ref="upload"
                    name="file"
                    :data="dataEdit"
                    :auto-upload=false
                    :on-change="handleChange"
                    :file-list="fileList3" v-if="item.type=='file'">
                      <el-button size="small" type="primary" >点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                  </el-upload>
              </div>
          </div>
          <span slot="footer" class="dialog-footer">
              <el-button @click="dialogEdit = false">取 消</el-button>
              <el-button type="primary" @click="documentEdit">确 定</el-button>
          </span>
       </el-dialog>

      <!--添加审批-->
      <el-dialog title="新建审批" :visible.sync="dialogAdd_approval" width="1000px" :height="(height/2)" :before-close="handleClose">
       <div class="approval">
          <div  v-for="(item,index) in templates" :key="index+''">
              <v-input v-if="item.type=='input'" :moduel="item" :projectData ="approval_data"  :ref="'approval'+item.key_name" v-model='approval_data[item.key_name]'></v-input>
              <v-select v-if="item.type=='select'" :moduel="item" :projectData.sync ="approval_data"  v-model='approval_data[item.key_name]' :ref="'approval'+item.key_name"> </v-select>
              <v-select_flow v-if="item.type=='select_flow'" :moduel.sync="item" :projectData.sync="approval_data" v-model='approval_data[item.key_name]' :ref="'approval'+item.key_name" >> </v-select_flow>
              <v-select_flow v-if="item.type=='select_project_user'" :moduel.sync="item" :projectData.sync="approval_data" v-model='approval_data[item.key_name]'  :ref="'approval'+item.key_name"> </v-select_flow>
              <uc_editor v-if="item.type=='text'"  :moduel="item" :data.sync="approval_data" v-model='approval_data[item.key_name]' :ref="'approval'+item.key_name" :input_callback="set_add_project_description" type='audit'></uc_editor>
              <div v-if="item.key_name=='document_ids'" style="vertical-align: top">
                  <v-selectFile_multiple :moduel="item" :projectData.sync ="approval_data" ref="approvalfiles"  v-on:listenToChildEvent="relative_documents"></v-selectFile_multiple>
                  <el-upload
                    class="upload-demo"
                    :action="upload_url"
                    :show-file-list="false"
                    ref="upload_approval"
                    name="file"
                    :data='upload_file_data_approval'
                    :auto-upload='true'
                    :file-list="fileList_approval"  :limit='limit'>
                    <span class="function_btn" style="color: #0099CC;">上传附件</span>
                  </el-upload>
                  <span>(温馨提示：支持上传word、excel、ppt、pdf、图片)</span>
              </div>
          </div>

          <el-table
            :data="documentsList"
            style="width: 800px">
            <el-table-column prop="name" label="文档名称"></el-table-column>
            <el-table-column width="180" label="操作"><template slot-scope="scope"><el-button type="danger" plain size="small" @click="delDocumentFormTable(scope.$index,scope.row.id)">删除</el-button></template></el-table-column>
          </el-table>
       </div>
       <span slot="footer" class="dialog-footer">
          <el-button @click="dialogAdd_approval = false">取 消</el-button>
          <el-button type="primary" @click="add_approval">创建审批</el-button>
          <div style="color: red;text-align: right">{{tips_approval}}</div>
       </span>
      </el-dialog>
   </div>
</template>
<style>
  .projectList{
      margin: 10px 0;
  }
  .title{
      font-size: 14px;
      font-weight: bold;
  }
   table.gridtable {
    font-family: verdana,arial,sans-serif;
    font-size:11px;
    color:#333333;
    border-width: 1px;
    border-color: #666666;
    border-collapse: collapse;
    width: 95%;
    }
    table.gridtable th {
        border-width: 1px;
        padding: 4px;
        border-style: solid;
        border-color: #666666;
        /* background-color: #dedede; */
    }
    table.gridtable td {
        border-width: 1px;
        padding: 4px;
        border-style: solid;
        border-color: #666666;
        background-color: #ffffff;

    }
    .col1 { width: 5%; text-align: center; }
    .col2 { width: 10%; text-align: center; }
    .col3 { width: 10%; text-align: center;  }
    .col4 { width: 5%; text-align: center; }
    .col5 { width: 10%; text-align: center; }
    .col6 { width: 5%; text-align: center; }
    .col7 { width: 5%; text-align: center; }
    .col8 { width: 10%; text-align: center; }
    .col9 { width: 5%; text-align: center; }
    .col10 { width: 35%; text-align: center; }
</style>
<script>
    export default {
        name:'projectLists',
        data(){
            return {
                page:'docuement',
                limit:1,
                dialogEdit:false,
                dataInit:{},
                dataEdit:{},
                id:'',
                fileList3:[],
                templates:[],
                fileList_approval:[],
                documentsList:[],
                tips_approval:'',
                approval_data:{},
                upload_url:'',
                header:60,                
                pagination_height:30,
                pageSize:10,
                dialogAdd_approval:false,
                upload_file_data_approval:{},
                sort:[{value:1,lable:'倒序'},{value:2,lable:'正序'}],
                order_by:[{value:'name',lable:'名称'},{value:'status',lable:'状态'},{value:'create_time',lable:'创建时间'}],
                getDataParam:{page:1,limits:10,my_approval:true,my_create:true,underway:true,is_finish:true,is_failure:true,is_correct:true,is_abend:true,order_by:'',sort:''},
                web_token: "",
                web_url:""
            }
        },
        props: ["height", "width","user_info","lists"],
        methods: {
            indexMethod(index) {
                return index +1;
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            clearFiles(){
                this.$refs.upload[0].clearFiles();
                this.dataEdit.file = '';
            },
            handleChange(file, fileList) {
                this.fileList3 = fileList.slice(-3);
                this.$refs.file_id[0].clearValue();
            },
            handleSuccess(){
                this.dialogAdd = false;
                this.clearData();
            },
            documentEdit(){
                this.dataEdit.web_token = this.web_token;
                this.$http.post(this.web_url+'/document/'+this.id+'/edit',this.dataEdit,{emulateJSON:true}).then(function(res){
                    // console.log(this.templates);
                    if(res.data.status == 'ok'){
                        this.dialogEdit = false;
                        // console.log(this.dialogEdit );
                        this.$emit('listenToChildEvent')
                    }else {

                    }
                })
                    .catch(function(res1){
                        // console.log(res1);
                    });
            },
            set_add_project_description: function(_content, _height){
              this.approval_data.description = _content;
              // this.approval_data.description_high = _height;
            },
            //添加审批
            add_approval(){
              this.approval_data.document_ids = [];
              for (var i =0; i < this.documentsList.length;i++){
                this.approval_data.document_ids.push(this.documentsList[i].id);
              }
              var _this = this;
              this.approval_data.web_token = this.web_token;
              this.$http.post(this.web_url+'/approval/apply',this.approval_data,{emulateJSON:true}).then(function(res){
                if(res.data.status == 'ok'){
                  this.get_approval();
                  this.tips_approval =  '';
                  this.dialogAdd_approval = false;

                  //清空选项中的数据
                  for(var i=0; i< this.templates.length; i++) {
                    var ref = 'approval'+this.templates[i].key_name;
                    if(this.templates[i].key_name != 'document_ids'){
                      this.$refs[ref][0].clear();
                    }
                  }
                  this.$refs.approvalfiles[0].clear();
                  this.documentsList = [];
                  this.files = [];
                  this.resetparem_approval();

                }else if(res.data.error_code == '401'){
                  this.backToLogin();
                }else {
                  _this.tips_approval = '请检查再提交，必填项不能为空';
                  setTimeout(function () {
                    _this.tips_approval =  '';
                  },5000)
                }
              })
              .catch(function(res1){
                console.log(res1);
              });
            },
            //关联文档
            relative_documents(res){
              var documents = [];
              for(var i =0; this.files_total.length > i; i++){
                if( res.indexOf(this.files_total[i].id)>-1){
                  documents.push(this.files_total[i]);
                }
              }
              this.documentsList = documents.concat(this.files);
            },
            //删除
            delDocumentFormTable(index,id){
              this.documentsList.splice(index,1);
              var ref = 'approvalfiles';
              this.$refs[ref][0].del(id);
            },
            //获取审批模板
            getTemplate:function(){
                this.$http.post(this.web_url+'/project/vue_template',{web_token:this.web_token,system:'web',model_id:7},{emulateJSON:true}).then(function(res){
                    // console.log(this.templates);
                    if(res.data.status == 'ok'){
                          this.templates = res.data.data;
                          this.resetparem_approval();
                    }else if(res.data.error_code == '401'){
                      this.backToLogin();
                    }

                  })
                .catch(function(res1){
                  console.log(res1);
                });
            },
            //重置参数 添加审批
            resetparem_approval(){
              this.approval_data = {};
              var arr = ['select_upload_file','select_flow','select_project_user']
              for(var i=0; i< this.templates.length; i++) {
                if(arr.indexOf(this.templates[i].type) > -1){
                    this.approval_data[this.templates[i].key_name] = [];
                }else {
                  this.approval_data[this.templates[i].key_name] = '';
                }
              }
            },
            documentEditDetail(row){
              // console.log(row);
                this.id = row.id;
                this.$http.post(this.web_url+'/document/'+row.id,{web_token:this.web_token},{emulateJSON:true}).then(function(res){
                    if(res.data.status == 'ok'){
                        this.dataInit =  res.data.data;
                        //  赋值projectData
                        for(var i =0; this.templates.length > i; i++){
                            this.dataEdit[this.templates[i].key_name] = this.dataInit[this.templates[i].key_name];
                        }
                        this.fileList3 = [];
                        var obj = {name:this.dataInit.file.name,url:this.dataInit.file.fileurl}
                        this.fileList3.push(obj);
                        this.dialogEdit = true;
                    }else {

                    }
                })
                .catch(function(res1){
                    // console.log(res1);
                });
            },
            getTaskList:function(){
                this.$refs.task_id[0].clearValue();
                this.$http.post(this.web_url+'/task/select/'+this.id,{web_token:this.web_token},{emulateJSON:true}).then(function(res){
                    if(res.data.status == 'ok'){
                        for(var i=0; i< this.templates.length; i++) {
                            if(this.templates[i].key_name == 'task_id'){
                                this.dataEdit.task_id = '';
                                this.templates[i].select_obj = res.data.data;
                            }
                        }
                    }else {

                    }
                })
                .catch(function(res1){
                    console.log(res1);
                });
            },
            //获取审批
            get_approval:function(){
              this.getDataParam.web_token = this.web_token;
              this.$http.post(this.web_url+'/approval',this.getDataParam,{emulateJSON:true}).then(function(res){
                if(res.data.status == 'ok'){
                  this.lists = res.data.data;
                }else if(res.data.error_code == '401'){
                  this.backToLogin();
                }
              })
              .catch(function(res1){
                console.log(res1);
              });
            },
            //更新列表数据
            updateData(val){
              this.getDataParam.page = val;
              this.get_approval();
            },
            douwnload(row){
                // console.log(row)
                window.open(row.file.fileurl,'_blank')
            },
            upDate(val){
                this.$emit('listenToChildEvent',val);
            },
            taskAdd(row){
//          this.dialogEdit = true;
            },
            detail(row){
              // console
              let routeUrl = this.$router.resolve({
                path: "/approval_detail/"+row.id,
                query: {id:row.id}
              });
              window.open(routeUrl .href, '_blank');
                // this.$router.push({path:'/approval_detail/'+row.id,params:{id:row.id} });
            }
        },
        mounted() {
            this.appUrl = this.web_url + '/download_apk.png'
            this.upload_url = this.web_url+'/document/add';
            this.upload_file_data_approval.web_token = this.web_token;
            // this.getTemplate();
            // this.get_approval();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/audit.vue